var render = function render(){var _vm=this,_c=_vm._self._c;return _c('send-modal',{attrs:{"title":_vm.title,"change-display":_vm.changeDisplay,"selected-responses-ids":_vm.selectedResponsesIds,"responses":_vm.responses,"create-send-data":_vm.createSendData,"initial-body":_vm.signature,"body_template":_vm.template,"is-link-share-shown":_vm.isLinkShareShown,"api-method":"shareLink"}})
}
var staticRenderFns = []

export { render, staticRenderFns }